module.exports = __webpack_public_path__ + "static/img_4913-4d41bc8db35fc1cb4a68e31e8ac26e5a.webp";